export const LISTAR_VIDEOS = 'LISTAR_VIDEOSS';
export const REQUEST_VIDEOS = 'REQUEST_VIDEOSS';
export const SALVAR_VIDEO = 'SALVAR_VIDEO';
export const EDITAR_VIDEO = 'EDITAR_VIDEOS';
export const GET_VIDEO_ID = 'GET_VIDEOS_ID';
export const TOGGLE_VIDEO = 'TOGGLE_VIDEO';